import "./LoginPage.css";
import { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation, useSearchParams, Link } from 'react-router-dom';
import login_icon from "../assets/login_icon.png";
import EmailInputComponent from "../components/EmailInputComponent";
import PasswordInputcomponent from "../components/PasswordInputComponent";
import LogicContext from "../Context/LogicContext";
import { authenticationService } from "../services/authentication.service";
import { currentMenuListAtom } from "../store/storeMenuAtom";
import { useResetRecoilState } from "recoil";
import Container from "../components/my-container/Container";
import DelgroLogo from "../components/delgro_logo/DelgroLogo";

function LoginPage() {
  const logicContext = useContext(LogicContext);
  const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const resetCurrentMenu = useResetRecoilState(currentMenuListAtom);

  useEffect(() => {
    resetCurrentMenu();
  }, []);

  function handleSubmit(event) {
    event.preventDefault();
    if (!email || !password)
      return logicContext.showToast("One or more input is required!");

     authenticationService.login({email:email, password: password}).then((res) => {
      const data = res.data;
      
    
        if (data["token"]) {
          localStorage.setItem("token", data["token"]);
          logicContext.setModuleList(data["moduleList"]);
        
           const returnUrl = searchParams.get('returnUrl') || location.state?.from?.pathname || '/Users/module-list';

           // Navigate to the return URL
           navigate(returnUrl, { replace: true });
         
          navigate(returnUrl);
        } else if (data["msg"]) {
          logicContext.showToast(data["msg"], "error");
        }
      }).catch((err)=> {
        console.log("login_error ", err);
        logicContext.showToast("Login failure, please contact Administrator", "error");

      })
  }

  return (
    <div className="bg-white min-h-screen">
      <Container>
        <div className="max-w-[1050px] mx-auto">
          <div className="pt-6 px-2 md:px-6">
            <DelgroLogo />
          </div>

          <div className="mt-8 grid grid-cols-1 md:grid-cols-9 gap-10 items-center px-2 md:px-6">
            {/* Left: Intro and Image */}
            <div className="md:col-span-5 flex flex-col items-start">
              <h3 className="text-[min(5vw,25px)] font-extrabold text-gray-700  max-w-md">
                You are about to enter a productive zone where the impossible is
                possible.
              </h3>
              <img
                src={login_icon}
                alt="Login Illustration"
                className="mt-6 w-full max-w-[370px] object-contain"
              />
            </div>

            {/* Right: Login Form */}
            <div className="md:col-span-4 w-full max-w-md mx-auto">
              <h1 className="text-3xl font-bold text-gray-600 mb-6">
                Welcome back
              </h1>
              <form onSubmit={handleSubmit} className="space-y-6">
                <EmailInputComponent
                  emailOnchange={(email) => setEmail(email)}
                />
                <PasswordInputcomponent
                  passwordChange={(pwd) => setPassword(pwd)}
                />

                <button
                  type="submit"
                  className="w-full py-3 text-sm font-semibold tracking-wider rounded-md bg-blue-600 text-white shadow-md hover:bg-blue-700 transition-all duration-300"
                >
                  Log In
                </button>
              </form>
              <div className="mt-2 mb-20 md:mb-0  flex justify-end">
                <Link
                  to="/forget-password"
                  className="w-fit text-base font-medium text-blue-600 hover:underline hover:underline-offset-2"
                >
                  Forgot Password?
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default LoginPage;
